<template>
    <div ref="mdshow" class="markdownshow" style="">
        <vue-markdown :source="source" :show="true" 
          :prerender="mdPre"
          :postrender="mdPost"
          @rendered="renderedHook"
          ></vue-markdown> 
          <!-- :prerender="mdPre" -->
    </div>
</template>

<script>
import Prism from 'prismjs'
import "prismjs/themes/prism-okaidia.css"
import 'prismjs/components/prism-apacheconf'
import 'prismjs/components/prism-awk'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-batch'
import 'prismjs/components/prism-c'
import 'prismjs/components/prism-clojure'
import 'prismjs/components/prism-cmake'
import 'prismjs/components/prism-cobol'
import 'prismjs/components/prism-cpp'
import 'prismjs/components/prism-csharp'
import 'prismjs/components/prism-cshtml'
import 'prismjs/components/prism-csp'
import 'prismjs/components/prism-css-extras'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-csv'
import 'prismjs/components/prism-cue'
import 'prismjs/components/prism-cypher'
import 'prismjs/components/prism-d'
import 'prismjs/components/prism-dart'
import 'prismjs/components/prism-dataweave'
import 'prismjs/components/prism-dax'
import 'prismjs/components/prism-dhall'
import 'prismjs/components/prism-diff'
import 'prismjs/components/prism-dns-zone-file'
import 'prismjs/components/prism-docker'
import 'prismjs/components/prism-dot'
import 'prismjs/components/prism-ebnf'
import 'prismjs/components/prism-eiffel'
import 'prismjs/components/prism-ejs'
import 'prismjs/components/prism-elixir'
import 'prismjs/components/prism-elm'
import 'prismjs/components/prism-erb'
import 'prismjs/components/prism-erlang'
import 'prismjs/components/prism-etlua'
import 'prismjs/components/prism-excel-formula'
import 'prismjs/components/prism-factor'
import 'prismjs/components/prism-firestore-security-rules'
import 'prismjs/components/prism-flow'
import 'prismjs/components/prism-fortran'
import 'prismjs/components/prism-fsharp'
import 'prismjs/components/prism-ftl'
import 'prismjs/components/prism-gap'
import 'prismjs/components/prism-gcode'
import 'prismjs/components/prism-gdscript'
import 'prismjs/components/prism-gedcom'
import 'prismjs/components/prism-gettext'
import 'prismjs/components/prism-gherkin'
import 'prismjs/components/prism-git'
import 'prismjs/components/prism-glsl'
import 'prismjs/components/prism-gml'
import 'prismjs/components/prism-gn'
import 'prismjs/components/prism-go-module'
import 'prismjs/components/prism-go'
import 'prismjs/components/prism-gradle'
import 'prismjs/components/prism-graphql'
import 'prismjs/components/prism-groovy'
import 'prismjs/components/prism-haml'
import 'prismjs/components/prism-handlebars'
import 'prismjs/components/prism-haskell'
import 'prismjs/components/prism-haxe'
import 'prismjs/components/prism-hcl'
import 'prismjs/components/prism-hlsl'
import 'prismjs/components/prism-hoon'
import 'prismjs/components/prism-hpkp'
import 'prismjs/components/prism-hsts'
import 'prismjs/components/prism-http'
import 'prismjs/components/prism-ichigojam'
import 'prismjs/components/prism-icon'
import 'prismjs/components/prism-icu-message-format'
import 'prismjs/components/prism-idris'
import 'prismjs/components/prism-iecst'
import 'prismjs/components/prism-ignore'
import 'prismjs/components/prism-inform7'
import 'prismjs/components/prism-ini'
import 'prismjs/components/prism-io'
import 'prismjs/components/prism-j'
import 'prismjs/components/prism-java'
//import 'prismjs/components/prism-javadoc'
import 'prismjs/components/prism-javadoclike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-javastacktrace'
import 'prismjs/components/prism-jexl'
import 'prismjs/components/prism-jolie'
import 'prismjs/components/prism-jq'
import 'prismjs/components/prism-js-extras'
import 'prismjs/components/prism-js-templates'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-json5'
import 'prismjs/components/prism-jsonp'
import 'prismjs/components/prism-jsstacktrace'
import 'prismjs/components/prism-jsx'
import 'prismjs/components/prism-julia'
import 'prismjs/components/prism-keepalived'
import 'prismjs/components/prism-keyman'
import 'prismjs/components/prism-kotlin'
import 'prismjs/components/prism-kumir'
import 'prismjs/components/prism-kusto'
import 'prismjs/components/prism-latex'
import 'prismjs/components/prism-latte'
import 'prismjs/components/prism-less'
import 'prismjs/components/prism-lilypond'
import 'prismjs/components/prism-linker-script'
import 'prismjs/components/prism-liquid'
import 'prismjs/components/prism-lisp'
import 'prismjs/components/prism-livescript'
import 'prismjs/components/prism-llvm'
import 'prismjs/components/prism-log'
import 'prismjs/components/prism-lolcode'
import 'prismjs/components/prism-lua'
import 'prismjs/components/prism-magma'
import 'prismjs/components/prism-makefile'
import 'prismjs/components/prism-markdown'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-mata'
import 'prismjs/components/prism-matlab'
import 'prismjs/components/prism-maxscript'
import 'prismjs/components/prism-mel'
import 'prismjs/components/prism-mermaid'
import 'prismjs/components/prism-metafont'
import 'prismjs/components/prism-mizar'
import 'prismjs/components/prism-mongodb'
import 'prismjs/components/prism-monkey'
import 'prismjs/components/prism-moonscript'
import 'prismjs/components/prism-n1ql'
import 'prismjs/components/prism-n4js'
import 'prismjs/components/prism-nand2tetris-hdl'
import 'prismjs/components/prism-naniscript'
import 'prismjs/components/prism-nasm'
import 'prismjs/components/prism-neon'
import 'prismjs/components/prism-nevod'
import 'prismjs/components/prism-nginx'
import 'prismjs/components/prism-nim'
import 'prismjs/components/prism-nix'
import 'prismjs/components/prism-nsis'
import 'prismjs/components/prism-objectivec'
import 'prismjs/components/prism-ocaml'
import 'prismjs/components/prism-odin'
import 'prismjs/components/prism-opencl'
import 'prismjs/components/prism-openqasm'
import 'prismjs/components/prism-oz'
import 'prismjs/components/prism-parigp'
import 'prismjs/components/prism-parser'
import 'prismjs/components/prism-pascal'
import 'prismjs/components/prism-pascaligo'
import 'prismjs/components/prism-pcaxis'
import 'prismjs/components/prism-peoplecode'
import 'prismjs/components/prism-perl'
import 'prismjs/components/prism-php-extras'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-phpdoc'
import 'prismjs/components/prism-plant-uml'
import 'prismjs/components/prism-powerquery'
import 'prismjs/components/prism-powershell'
import 'prismjs/components/prism-processing'
import 'prismjs/components/prism-prolog'
import 'prismjs/components/prism-promql'
import 'prismjs/components/prism-properties'
import 'prismjs/components/prism-protobuf'
import 'prismjs/components/prism-psl'
import 'prismjs/components/prism-pug'
import 'prismjs/components/prism-puppet'
import 'prismjs/components/prism-pure'
import 'prismjs/components/prism-purebasic'
import 'prismjs/components/prism-purescript'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-q'
import 'prismjs/components/prism-qml'
import 'prismjs/components/prism-qore'
import 'prismjs/components/prism-qsharp'
import 'prismjs/components/prism-r'
import 'prismjs/components/prism-reason'
import 'prismjs/components/prism-regex'
import 'prismjs/components/prism-rego'
import 'prismjs/components/prism-renpy'
import 'prismjs/components/prism-rescript'
import 'prismjs/components/prism-rest'
import 'prismjs/components/prism-rip'
import 'prismjs/components/prism-roboconf'
import 'prismjs/components/prism-robotframework'
import 'prismjs/components/prism-ruby'
import 'prismjs/components/prism-rust'
import 'prismjs/components/prism-sas'
import 'prismjs/components/prism-sass'
import 'prismjs/components/prism-scala'
import 'prismjs/components/prism-scheme'
import 'prismjs/components/prism-scss'
import 'prismjs/components/prism-shell-session'
import 'prismjs/components/prism-smali'
import 'prismjs/components/prism-smalltalk'
import 'prismjs/components/prism-smarty'
import 'prismjs/components/prism-sml'
import 'prismjs/components/prism-solidity'
import 'prismjs/components/prism-solution-file'
import 'prismjs/components/prism-soy'
import 'prismjs/components/prism-splunk-spl'
import 'prismjs/components/prism-sqf'
import 'prismjs/components/prism-sql'
import 'prismjs/components/prism-squirrel'
import 'prismjs/components/prism-stan'
import 'prismjs/components/prism-stata'
import 'prismjs/components/prism-stylus'
import 'prismjs/components/prism-supercollider'
import 'prismjs/components/prism-swift'
import 'prismjs/components/prism-systemd'
import 'prismjs/components/prism-t4-templating'
import 'prismjs/components/prism-t4-vb'
import 'prismjs/components/prism-tap'
import 'prismjs/components/prism-tcl'
import 'prismjs/components/prism-textile'
import 'prismjs/components/prism-toml'
import 'prismjs/components/prism-tremor'
import 'prismjs/components/prism-tsx'
import 'prismjs/components/prism-tt2'
import 'prismjs/components/prism-turtle'
import 'prismjs/components/prism-twig'
import 'prismjs/components/prism-typescript'
import 'prismjs/components/prism-typoscript'
import 'prismjs/components/prism-unrealscript'
import 'prismjs/components/prism-uorazor'
import 'prismjs/components/prism-uri'
import 'prismjs/components/prism-v'
import 'prismjs/components/prism-vala'
import 'prismjs/components/prism-velocity'
import 'prismjs/components/prism-verilog'
import 'prismjs/components/prism-vhdl'
import 'prismjs/components/prism-vim'
import 'prismjs/components/prism-visual-basic'
import 'prismjs/components/prism-warpscript'
import 'prismjs/components/prism-wasm'
import 'prismjs/components/prism-web-idl'
import 'prismjs/components/prism-wgsl'
import 'prismjs/components/prism-wiki'
import 'prismjs/components/prism-wolfram'
import 'prismjs/components/prism-wren'
import 'prismjs/components/prism-xeora'
import 'prismjs/components/prism-xml-doc'
import 'prismjs/components/prism-xojo'
import 'prismjs/components/prism-xquery'
import 'prismjs/components/prism-yaml'
import 'prismjs/components/prism-yang'
import 'prismjs/components/prism-zig'

// import M from 'materialize-css'

// https://stackoverflow.com/questions/6234773/can-i-escape-html-special-chars-in-javascript
function escapeHtml(unsafe) {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

//https://stackoverflow.com/questions/4009756/how-to-count-string-occurrence-in-string
function occurrences(string, subString, allowOverlapping) {

string += "";
subString += "";
if (subString.length <= 0) return (string.length + 1);

var n = 0,
    pos = 0,
    step = allowOverlapping ? 1 : subString.length;

while (true) {
    pos = string.indexOf(subString, pos);
    if (pos >= 0) {
        ++n;
        pos += step;
    } else break;
}
return n;
}


import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import photoswipe from 'photoswipe/dist/photoswipe.esm'

  const copyToClipboard = str => {
	  const el = document.createElement('textarea');
	  el.value = str;
	  document.body.appendChild(el);
	  el.select();
	  document.execCommand('copy');
	  document.body.removeChild(el);
	};

export default {
    name: '',
    props: ['source'],
    components: {

    },
    data(){
        return {
          materialbox: null,
          galleryid: [],
        }
    },
    mounted(){

    },
    methods: {
      mdPre(text){
        if (this.$refs.mdshow){
          console.log('mdshow $refs')
          let bcr = this.$refs.mdshow.getBoundingClientRect()
          console.log('mypreset to ', bcr.height, this.$refs.mdshow)
          this.$refs.mdshow.style.height = `${bcr.height+200}px`
          this.$refs.mdshow.style.minHeight = `${bcr.height+200}px`
          this.$refs.mdshow.setAttribute('myHeight', bcr.height)
        }else{
          console.log('mdshow $refs not found')
          let tempdiv = document.querySelector('.markdownshow')
          if (tempdiv){
            let bcr = tempdiv.getBoundingClientRect()
            console.log('mypreset to ', bcr.height, tempdiv)
            tempdiv.style.height = `${bcr.height+200}px`
            tempdiv.style.minHeight = `${bcr.height+200}px`
            tempdiv.setAttribute('myHeight', bcr.height)
          }else{
            console.log('tempdiv not found')
          }
        }
        let galleryid = []
        let text0 = []
        let galleryactive = false
        let galleryindexactive = 0
        for (let line of text.split("\n")){
          let lineraw = line
          if (line.startsWith('::gallery-start')) {
            galleryactive = true
            galleryid.push(galleryindexactive)
            line = `<div class="pswp-gallery pswp-gallery--single-column" id="gallery${galleryindexactive}">`
            text0.push(line)
            continue
          }
          if (line.startsWith('::gallery-end')) {
            galleryactive = false
            galleryindexactive += 1
            line = `</div><div style="width:100%;clear:both;"></div>`
            text0.push(line)
            continue
          }
          if (galleryactive){
            // ![]()k
            console.log('line', line)
            let m = line.match(/.*?\((.*)\).*/) 
            console.log('m', m)
            if (m){
              let link = m[1]
              //let img = new Image()
              //img.onload = function(){
              //  console.log('img loaded', this, this.width, this.height)
              //  // line = `<a href="${link}" 
              //  //     target="_blank">
              //  //     <img project="gallery" data-pswp-width="${this.width}" data-pswp-height="${this.height}" src="${link}" style="width:80px;height:80px;float:left;margin:1px;" alt="" />
              //  //   </a>`
              //}
              //img.src = link
              line = `<a href="${link}" 
                  data-pswp-width="800"
                  data-pswp-height="600"
                  target="_blank">
                  <img project="gallery" src="${link}" style="width:80px;height:80px;float:left;margin:1px;" alt="" />
                </a>`
            }else{
              continue
            }
          }
          text0.push(line)
        }
        text = text0.join("\n")
        console.log('text final', text)
        this.galleryid = galleryid

        return text
        let ret = '' 

        
        let finala = ''
        let totable = false
        let row = []
        let rows = []
        let indents = 0
        let cindent = 0
        let header = []



        for (let line of text.split("\n")){
          let rawline = line
          console.log('>>>rawline', rawline)
          if (line.replace(/\s/, '') == '' && totable){
            rows.push([...row])
            console.log('rows', rows)
            totable = false
            let maxrow = rows.reduce((g,c,i) => {
              return Math.max(g, c.length)
            }, 0)

            let afinal = rows.map(d => {
              d = ['', ...d.map(d => d.val), '']
              return d.join('|')
            })

            afinal = [
              ['', ...header.concat([...new Array(maxrow-header.length)].map(d => '')), ''].join('|'),
              ['', ...[...new Array(maxrow)].map(d => '---'), ''].join('|'),
              ...afinal,
            ]

            ret += afinal.join('\n')
            ret += "\n"
            continue
          }
          console.log(line, totable, row)
          if (line.includes('--totable')){
            header = line.replace('--totable', '').split(',').map(d => d.trim())
            totable = true
          }else if (totable){
            if (line.match('^[ ]*?\\*.*')){
              console.log('****')
              line = line.replace(/^(\s+)?(\*)(\s+)/, '$1 $3')
              let _indent = line.match('^[ ]+')[0].length
              let _indent2 = row.length*2 || _indent2
              let val = line.replace(/^[ ]+/, '')
              console.log('>>>line', line, '| _indent', _indent, '| cindent', cindent, '| _indent2', _indent2)
              if (_indent <= cindent){
                console.log('reduce')
                rows.push([...row])
                console.log('row before slice', row.map(d => d.val))
                // row = row.slice(0, row.length-(1+occurrences(row[row.length-1].line, '-.')))
                if (_indent-2 == 0){
                  row = [{
                    val,
                    line: rawline,
                  }]
                }else{
                  row = row.slice(0, _indent-2)
                }
                console.log('row after slice', row.map(d => d.val))
              }else{
                console.log('add')
                val = val.split('-.').map(d => d.trim()).map(d => {
                  console.log('d', d)
                  return{
                    val: d,
                    line: rawline,
                  }
                })
                row = row.concat(val)
              }
              cindent = _indent
            }else{
              console.log('----')
              let _indent = line.match('^[ ]+')[0].length
              let val = line.replace(/^[ ]+/, '')
              row[row.length-1].val += "<br>"+val
              row[row.length-1].line += "\n"+rawline
            }
          }else{
            console.log('hrere', '|', rawline, '|')
            ret += rawline+"\n"
          }
        }

        console.log('ret', ret)

        return ret
      },
      renderedHook(){
        if (this.$refs.mdshow || true){
          this.$nextTick(() => {
            Prism.highlightAll()
            setTimeout(() => {
              this.$refs.mdshow.style.height = null
              this.$refs.mdshow.style.minHeight = null
            }, 4000)
            console.log(this.$refs.mdshow)
            console.log('materialboxed', this.$refs.mdshow.querySelectorAll('.materialboxed'))
            this.M.Materialbox.init(this.$refs.mdshow.querySelectorAll('.materialboxed'))

            this.galleryid.map(d => {
              const lightbox = new PhotoSwipeLightbox({
                  // may select multiple "galleries"
                  gallery: '#gallery'+d,

                  initialZoomLevel: 'fit',

                  // Elements within gallery (slides)
                  children: 'a',

                  imageClickAction: 'close',
                  tapAction: 'close',
                  closeOnVerticalDrag: false,

                  // setup PhotoSwipe Core dynamic import
                  // pswpModule: () => import('/photoswipe/photoswipe.esm.js')
                  pswpModule: photoswipe
              });
              lightbox.init();
            })

              this.$el.querySelectorAll('p > code').forEach(function (el){
                  el.addEventListener('click', function (){
                      copyToClipboard(el.innerText)
                  })
              })
              this.$el.querySelectorAll('li > code').forEach(function (el){
                  el.addEventListener('click', function (){
                      copyToClipboard(el.innerText)
                  })
              })
              this.$el.querySelectorAll('a').forEach(function (el){
                el.setAttribute('target', '_blank')
              })

            	this.$el.querySelectorAll('pre').forEach(function (el){
                // let button = $('<button>', { style: 'font-size:12px;display:none;position:absolute;top:3px;right:3px;z-index:10;color:black;'} ).text('copy');
                let button = document.createElement('button')
                button.setAttribute('style', 'font-size:12px;display:none;position:absolute;top:3px;right:3px;z-index:10;color:black;')
                button.innerText = 'copy'
                let txt = el.innerText;
                el.style.position = 'relative'
                button.addEventListener('click', function (){
                  copyToClipboard(txt);
                });
                el.addEventListener('mouseenter', function (){
                  button.style.display = 'block'
                })
                el.addEventListener('mouseleave', function (){
                  button.style.display = 'none'
                })
                el.prepend(button)
              });

          // vimtabs start
          let tabidx = 0
          this.$refs.mdshow.querySelectorAll('p')
              .forEach(e => {
                if (e.innerHTML.startsWith('vimtabs')){ // vimtabs-<label> : <b64>
                  console.log('mdrendered vimtabs', e)
                  let [m, title, b64] = e.innerHTML.match(/vimtabs-?([^:]*):\s+(.*)/)
                  title = title || 'vimtab'
                  let row = JSON.parse(atob(b64))
                  let html = []
                  let style = ''
                  let b64html = row.map(d => {
                    return `
                      <strong>${d.filename}</strong>
                      <pre>${d.content}</pre>
                    ` 
                  }).join("<br>")
                  b64html = btoa(b64html)
                  let b64md = row.map(d => {
                    return `\`${d.filename}\`\n` +
                      `\`\`\`\n${d.content}\n\`\`\`` 
                  }).join("  \n")
                  b64md = btoa(b64md)
                  let copyPasteBash = []
                  row.map(d => {
                    if (d.filename.includes('/')){
                      let basename = d.filename.split('/')
                      basename = basename.slice(0,basename.length-1).join('/')
                      copyPasteBash.push(`mkdir -p '${basename}'`)
                    }
                    copyPasteBash.push(`echo '${btoa(d.content)}' | base64 -d > ${d.filename}`)
                    if (d.filename == 'cmd'){
                      copyPasteBash.push(`chmod +x ${d.filename}`)
                    }
                  })
                  copyPasteBash = btoa(copyPasteBash.join("\n"))
                  html.push(`
                  <strong>${title}</strong>
                  <button type="button" onclick="copyToClipboard('${b64}')">copy bcode</button>
                  <button type="button" onclick="copyToClipboardRich('${b64html}', 1)">copy html</button>
                  <button type="button" onclick="copyToClipboard('${b64md}', 1)">copy md</button>
                  <button type="button" onclick="copyToClipboard('${copyPasteBash}', 1)">copy bash</button>
                  `)
                  // tab header
                  html.push(`<div class="tabheader g${tabidx}" style="max-height:500px;max-width:600px;overflow:scroll;">`)
                  row.map((d,idx) => {
                    if (idx == 0){
                      style = 'background-color:lightsalmon;'
                    }else{
                      style = ''
                    }
                    html.push(`<button type="button" style="${style}"
                      onclick="
                      let e = event
                      e.target.parentElement.querySelectorAll('button').forEach(d => {
                        d.style.backgroundColor = null
                      })
                      e.target.style.backgroundColor = 'lightsalmon'
                      document.querySelector('#tabcontent-g${tabidx}')
                        .querySelectorAll('pre').forEach(e => {
                        e.style.display = 'none'
                      })
                      document.querySelector('#tabns-c${tabidx}${idx}').style.display = null
                      document.querySelector('#control-g${tabidx}').querySelectorAll('button').forEach(e => {
                        e.idactive = ${idx}
                      })
                      "
                    >${d.filename}</button>`)
                  })
                  html.push('</div>')
                  // tab menu action
                  html.push(`<div id="control-g${tabidx}" style="max-width:600px;">`)
                  html.push(`<button type="button" 
                    onclick="copyToClipboard(document.querySelector(\`#tabns-c${tabidx}\${event.target.idactive||0}\`).innerText)">copy</button>`)
                  html.push(`<button type="button" 
                    onclick="copyToClipboardRich('<pre>'+document.querySelector(\`#tabns-c${tabidx}\${event.target.idactive||0}\`).innerText+'</pre>')">copy pre</button>`)
                  html.push('</div>')
                  // tab content
                  html.push(`<div id="tabcontent-g${tabidx}" style="min-height:500px;max-height:500px;max-width:600px;overflow:scroll;">`)
                  row.map((d,idx) => {
                    if (idx == 0){
                      style=""
                    }else{
                      style="display:none;"
                    }
                    html.push(`<pre id="tabns-c${tabidx}${idx}" style="${style}">${escapeHtml(d.content)}</pre>`)
                  })
                  html.push('</div>')

                  e.innerHTML = html.join("")
                  tabidx+=1
                }
              })
          // vimtabs end
          })
        }
      },
      mdPost(e){
        console.log('post', e)
        const regexp = new RegExp('<img.*?alt="(.*?)"[^/]*?\/>', 'gm')
        let match
        while ((match = regexp.exec(e)) !== null) {
          console.log('m', match)
          if (match[0].includes('project="gallery"')) continue
          let rep = ''
          if (match[1]){
            let [w,h] = match[1].split('x')
            if (w)
              rep += ` width="${w}px" `
            if (h)
              rep += ` height="${h}px" `
            
            // e = e.replace(match[0], match[0].replace('/>', rep + ' />'))
          }
          e = e.replace(match[0], match[0].replace('/>', rep + ' class="materialboxed" style="max-width:100%;display:inline-block;"/>'))
        }
        console.log('post final', e)
        return e
      },
    },
}
</script>

<style>
.material-placeholder {
  display:inline-block;
}
</style>